import React from 'react';

const ProductImagePlaceholder = ({ type, color }) => {
  if (type === 'mac') {
    return (
      <div className="relative w-56 h-36 bg-[#1d1d1f] rounded-xl shadow-2xl transform transition-all duration-700 cubic-bezier(0.34, 1.56, 0.64, 1) group-hover:scale-110 group-hover:-translate-y-4 group-hover:rotate-1">
        <div className={`absolute inset-1 bg-[#000] rounded-lg overflow-hidden`}>
          <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-black opacity-80"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-12 h-12 rounded-full bg-gradient-to-tr from-blue-500/20 to-purple-500/20 blur-xl animate-pulse-slow"></div>
          </div>
          <div className="absolute -inset-full bg-gradient-to-tr from-transparent via-white/10 to-transparent rotate-45 transform translate-y-full group-hover:translate-y-[-200%] transition-transform duration-1000"></div>
        </div>
        <div className="absolute -bottom-1 left-0 right-0 h-1 bg-[#424245] rounded-b-xl"></div>
      </div>
    );
  }
  
  if (type === 'watch') {
    return (
      <div className="relative w-28 h-32 bg-[#2d2d2f] rounded-[2.5rem] shadow-2xl transform transition-all duration-700 cubic-bezier(0.34, 1.56, 0.64, 1) group-hover:scale-110 group-hover:-translate-y-4 group-hover:-rotate-2">
        <div className="absolute inset-1 rounded-[2.2rem] bg-black flex items-center justify-center">
          <div className="w-20 h-20 rounded-full border border-gray-700 bg-black relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-t from-orange-500/10 to-transparent animate-pulse-slow"></div>
          </div>
        </div>
        <div className={`absolute -top-6 left-1/2 -translate-x-1/2 w-20 h-8 ${color} rounded-t-lg -z-10 brightness-75`}></div>
        <div className={`absolute -bottom-6 left-1/2 -translate-x-1/2 w-20 h-8 ${color} rounded-b-lg -z-10 brightness-75`}></div>
      </div>
    );
  }

  return (
    <div className={`relative w-36 h-72 bg-[#1d1d1f] rounded-[3rem] shadow-2xl border-[6px] border-[#333] transition-all duration-700 cubic-bezier(0.34, 1.56, 0.64, 1) group-hover:scale-105 group-hover:-translate-y-4`}>
      <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-20 h-6 bg-black rounded-full z-20"></div>
      <div className={`absolute inset-0 rounded-[2.5rem] overflow-hidden ${color} opacity-90`}>
        <div className="absolute -inset-full bg-gradient-to-tr from-transparent via-white/10 to-transparent rotate-45 transform translate-y-full group-hover:translate-y-[-200%] transition-transform duration-1000"></div>
      </div>
    </div>
  );
};

export default ProductImagePlaceholder;